const getToken = () => {
    return JSON.parse(localStorage.getItem("key"));
};

const headers = {
    Accept: "application/json",
    "Content-Type": "application/json",
    authorization: "",
};

const userId = localStorage.getItem('userId');

export const setPermissions = (value, checked) => async (dispatch) => {
    dispatch({
        type: "SET_CHECKED",
        payload: value,
    });
};
export const unsetPermissions = (value, checked) => async (dispatch) => {
    dispatch({
        type: "SET_UNCHECKED",
        payload: value,
    });
};
export const setUsrePermissions = (user_id,system_type) => async (dispatch) => {

    let SERVER_URL = process.env.REACT_APP_API_URL;
    await fetch(SERVER_URL + `api/permission/getPermission`, {
        method: "POST",
        headers: { ...headers, authorization: `Bearer ${getToken()?.value}` },
        body: JSON.stringify({
            user_id: user_id
        }),
    })
        .then((res) => res.json())
        .then((data) => {
            var connect_permissions = '';
            if(system_type==1){
                var connect_permissions = data?.results[0]?.connect_permissions ? data.results[0].connect_permissions : "";
            }if(system_type==2){
                var connect_permissions = data?.results[0]?.access_permission ? data.results[0].access_permission : "";
            }
            dispatch({
                type: "SET_USER_PERMISSION",
                payload: connect_permissions ? JSON.parse(connect_permissions)?.split(',') : '',
            });
        })
};
export const setUsrePermissions_as_Null = () => async (dispatch) => {
    dispatch({
        type: "SET_NULL",
        payload: '',
    });
};